module.exports = __webpack_public_path__ + "img/house-empty.5c9fc264.png";